
  // Custom cursor
  const cursor = document.getElementById('cursor');
  const cursorRing = document.getElementById('cursorRing');
  let mouseX = 0, mouseY = 0;
  let ringX = 0, ringY = 0;

  document.addEventListener('mousemove', (e) => {
    mouseX = e.clientX; mouseY = e.clientY;
    cursor.style.left = mouseX + 'px';
    cursor.style.top = mouseY + 'px';
  });

  function animateRing() {
    ringX += (mouseX - ringX) * 0.12;
    ringY += (mouseY - ringY) * 0.12;
    cursorRing.style.left = ringX + 'px';
    cursorRing.style.top = ringY + 'px';
    requestAnimationFrame(animateRing);
  }
  animateRing();

  document.querySelectorAll('a, button, .product-card, .plan-card, .gallery-item').forEach(el => {
    el.addEventListener('mouseenter', () => cursorRing.classList.add('hover-active'));
    el.addEventListener('mouseleave', () => cursorRing.classList.remove('hover-active'));
  });

  // Nav scroll
  const nav = document.getElementById('mainNav');
  window.addEventListener('scroll', () => {
    nav.classList.toggle('scrolled', window.scrollY > 60);
  });

  // Fade up animations
  const fadeEls = document.querySelectorAll('.fade-up');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); } });
  }, { threshold: 0.15 });
  fadeEls.forEach(el => observer.observe(el));

  // Hero image loaded animation
  const heroImg = document.getElementById('heroImg');
  heroImg.onload = () => heroImg.classList.add('loaded');
  if (heroImg.complete) heroImg.classList.add('loaded');

  // Product filter
  function filterProducts(btn, roast) {
    document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    document.querySelectorAll('.product-card').forEach(card => {
      if (roast === 'all' || card.dataset.roast === roast) {
        card.style.display = '';
      } else {
        card.style.display = 'none';
      }
    });
  }

  // Cart
  let cart = [];

  function addToCart(name, price, img, size) {
    const existing = cart.find(i => i.name === name && i.size === size);
    if (existing) {
      existing.qty++;
    } else {
      cart.push({ name, price, img, size, qty: 1 });
    }
    updateCart();
    openCart();
  }

  function updateCart() {
    const count = cart.reduce((a, i) => a + i.qty, 0);
    document.getElementById('cartCount').textContent = count;

    const itemsEl = document.getElementById('cartItems');
    const footerEl = document.getElementById('cartFooter');

    if (cart.length === 0) {
      itemsEl.innerHTML = '<div class="cart-empty"><p>Your bag is empty</p><span>Add some beans and let&#x2019;s begin.</span></div>';
      footerEl.style.display = 'none';
      return;
    }

    footerEl.style.display = 'block';

    itemsEl.innerHTML = cart.map((item, idx) => `
      <div class="cart-item">
        <img class="cart-item-img" src="${item.img}" alt="${item.name}">
        <div>
          <p class="cart-item-name">${item.name}</p>
          <p class="cart-item-detail">${item.size} &times; ${item.qty}</p>
        </div>
        <span class="cart-item-price">${item.price}</span>
      </div>
    `).join('');

    // Simple total
    const total = cart.reduce((sum, item) => {
      const num = parseFloat(item.price.replace(/[^0-9.]/g, ''));
      return sum + (isNaN(num) ? 0 : num * item.qty);
    }, 0);
    document.getElementById('cartTotalPrice').textContent = '£' + total.toFixed(2);
  }

  function openCart() {
    document.getElementById('cartOverlay').classList.add('open');
    document.getElementById('cartSidebar').classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    document.getElementById('cartOverlay').classList.remove('open');
    document.getElementById('cartSidebar').classList.remove('open');
    document.body.style.overflow = '';
  }

  // Email submit
  function handleEmailSubmit() {
    const input = document.getElementById('emailInput');
    if (input.value && input.value.includes('@')) {
      input.value = '';
      alert('Thank you! Your 10% discount code has been sent to your inbox. Welcome to Signal.');
    } else {
      input.style.borderColor = 'rgba(255,100,100,0.5)';
      setTimeout(() => input.style.borderColor = '', 1500);
    }
  }

  // Mobile menu (simple toggle)
  function toggleMobileMenu() {
    // For a full implementation this would open a mobile nav
    // Simplified to scroll to top of page for demo
    window.scrollTo({top: 0, behavior: 'smooth'});
  }

  // Smooth scroll for nav links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });


// ================================================
// SHOPIFY CART AJAX
// ================================================

async function shopifyAddToCart(variantId, quantity) {
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    });
    const data = await res.json();
    if (data.status) {
      console.error('Cart error:', data.description);
      return null;
    }
    await updateCartCount();
    openCart();
    return data;
  } catch (err) {
    console.error('Add to cart failed:', err);
  }
}

async function updateCartCount() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    const countEl = document.getElementById('cartCount');
    if (countEl) countEl.textContent = cart.item_count;
    return cart;
  } catch (err) {
    console.error('Cart count update failed:', err);
  }
}

async function renderCartItems() {
  const cart = await updateCartCount();
  if (!cart) return;
  const itemsEl = document.getElementById('cartItems');
  const footerEl = document.getElementById('cartFooter');
  if (!itemsEl) return;

  if (cart.item_count === 0) {
    itemsEl.innerHTML = '<div class="cart-empty"><p>Your bag is empty</p><span>Add some beans and let\u2019s begin.</span></div>';
    if (footerEl) footerEl.style.display = 'none';
    return;
  }

  if (footerEl) footerEl.style.display = 'block';

  const itemsHTML = cart.items.map(item => `
    <div class="cart-item">
      <img class="cart-item-img" src="${item.image}" alt="${item.product_title}">
      <div>
        <p class="cart-item-name">${item.product_title}</p>
        <p class="cart-item-detail">${item.variant_title !== 'Default Title' ? item.variant_title : ''} &times; ${item.quantity}</p>
      </div>
      <span class="cart-item-price">${formatMoney(item.line_price)}</span>
    </div>
  `).join('');

  itemsEl.innerHTML = itemsHTML;
  const totalEl = document.getElementById('cartTotalPrice');
  if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
}

function formatMoney(cents) {
  return '\u00A3' + (cents / 100).toFixed(2);
}

// Override openCart to load live Shopify cart
const _origOpenCart = openCart;
function openCart() {
  document.getElementById('cartOverlay').classList.add('open');
  document.getElementById('cartSidebar').classList.add('open');
  document.body.style.overflow = 'hidden';
  renderCartItems();
}

// On page load, sync cart count
document.addEventListener('DOMContentLoaded', () => {
  updateCartCount();
});
